import {
	clearActiveSessionFamily,
	setActiveSessionFamily,
} from "@Front/Utils/lecoffreActiveSessionFamily";
import type { SessionPresenceSnapshot } from "./bootstrapSessionContextIsolationTypes";

export function persistActiveSessionFamilyForRoute(routeFamily: "client" | "notary", after: SessionPresenceSnapshot): void {
	if (routeFamily === "notary" && (after.hasNotaryStore || after.hasNotaryCookie)) {
		setActiveSessionFamily("notary");
		return;
	}
	if (routeFamily === "client") {
		if (after.hasCustomerStore || after.hasCustomerCookie) {
			setActiveSessionFamily("customer");
			return;
		}
		if (after.hasThirdPartyStore || after.hasThirdPartyCookie) {
			setActiveSessionFamily("thirdparty");
		}
	}
}

export function clearSessionFamilyWhenNoPresence(after: SessionPresenceSnapshot): void {
	const hasAnySession =
		after.hasNotaryStore ||
		after.hasNotaryCookie ||
		after.hasCustomerStore ||
		after.hasCustomerCookie ||
		after.hasThirdPartyStore ||
		after.hasThirdPartyCookie;
	if (!hasAnySession) {
		clearActiveSessionFamily();
	}
}
